
export const ApplicantMailIcon = ({
  primaryColor = 'var(--primary-bg-color)',
  secondColor = 'var(--primary-background-text-color',
}) => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <g
        id="Group_43569"
        data-name="Group 43569"
        transform="translate(-1129 -162)"
      >
        <g
          id="Group_43567"
          data-name="Group 43567"
          transform="translate(-213 -1)"
        >
          <circle
            id="Ellipse_1238"
            data-name="Ellipse 1238"
            cx="24"
            cy="24"
            r="24"
            transform="translate(1342 163)"
            fill={primaryColor}
          />
          <path
            id="mail"
            d="M27.747,78.913l6.989,6.992a3.933,3.933,0,0,0,5.542,0l6.989-6.992a.159.159,0,0,0-.022-.243,4.384,4.384,0,0,0-2.514-.792H30.283a4.385,4.385,0,0,0-2.514.792.159.159,0,0,0-.022.243Zm-1.868,3.368a4.37,4.37,0,0,1,.5-2.039.159.159,0,0,1,.254-.039l6.9,6.9a5.622,5.622,0,0,0,7.941,0l6.9-6.9a.159.159,0,0,1,.254.039,4.37,4.37,0,0,1,.5,2.039v9.193a4.408,4.408,0,0,1-4.4,4.4H30.283a4.408,4.408,0,0,1-4.4-4.4Z"
            transform="translate(1328.492 100.122)"
            fill={secondColor}
            fill-rule="evenodd"
          />
        </g>
      </g>
    </svg>
  );
};
